<ng-container>
	<nav class="fixed-navbar">
		<div class="container-fluid d-flex align-items-center top-bar">
            <button class="hamburger change" id="hamburger" (click)="toggleMyNav($event)" [attr.aria-label]="'ALT-TEXT.HAMBURGER' | translate">
                <div class="icon-bar1"></div>
                <div class="icon-bar2"></div>
                <div class="icon-bar3"></div>
            </button>
            <h1 class="logo mb-0" >
                @if(navbarTargetIsExternal){
                <a [href]="navbarTargetUrl" target="_blank" rel="noreferrer">
                    <img class="logo-image" alt="{{('ALT-TEXT.GO-TO-MAIN' | translate) ?? 'go to main page'}}" [src]="'../../../assets/images/nav-logo' + configurationService.navLogoExtension">
                </a>
                } @else {
                <a [routerLink]="navbarTargetUrl">
                    <img class="logo-image" alt="{{('ALT-TEXT.GO-TO-MAIN' | translate) ?? 'go to main page'}}" [src]="'../../../assets/images/nav-logo' + configurationService.navLogoExtension">
                </a>
                }
            </h1>
            @if(extraImageURL){
                <a class="extra-logo" [routerLink]="routerUtils.generateUrl(['home'])">
                    <img aria-hidden class="extra-logo-image" [src]="extraImageURL" alt="{{('ALT-TEXT.GO-TO-MAIN' | translate) ?? 'go to main page'}}" >
                </a>
            }

			<ul class="ml-auto horizontal-list justify-content-end" id="navigation">
                <li class="navbar-item-sm ml-auto">
                    <button mat-icon-button [matMenuTriggerFor]="toggleMenu" [attr.aria-label]="'ALT-TEXT.USER-OPTIONS' | translate">
                        <mat-icon aria-hidden>more_horiz</mat-icon>
                    </button>
                </li>

				<li class="new-plan-dialog col-md-auto ml-auto navbar-item-lg">
					<button type="button" mat-flat-button color="primary" class="start-new-plan-btn padded-shadow-btn" (click)="openNewPlanDialog()">{{ 'NAV-BAR.START-NEW-PLAN' | translate }}</button>
				</li>
				<li class="navbar-item-lg" *ngIf="!(isAuthenticated() && onInvalidUrl())">
					<button mat-button class="faq-title" (click)="openFaqDialog()">{{ 'FAQ.TITLE' | translate }}</button>
				</li>
                <li class="navbar-item-lg" *ngIf="isAuthenticated()">
					<button mat-button [matMenuTriggerFor]="tenantMenu" class="p-0 lang" [attr.aria-label]="'ALT-TEXT.TENANT-SELECT' | translate">
						<mat-icon aria-hidden class="m-0 material-symbols-rounded">tenancy</mat-icon>
						<mat-icon aria-hidden class="m-0">arrow_drop_down</mat-icon>
					</button>
					<mat-menu #tenantMenu="matMenu">
						<app-tenant-switch class="d-lg-block d-none"></app-tenant-switch>
					</mat-menu>
				</li>
			</ul>

			<mat-menu #toggleMenu="matMenu">
                <ul class="list m-2">
                    <li class="ml-3 d-flex justify-content-around align-items-center" (click)="$event.stopPropagation()" tabindex="0">
                        <button mat-button class="faq-title" (click)="openFaqDialog()" [attr.aria-label]="'FAQ.TITLE' | translate">{{ 'FAQ.TITLE' | translate }}</button>
                        <ng-container *ngIf="isAuthenticated()">
                            <button mat-button [matMenuTriggerFor]="tenantMenu" class="p-0" [attr.aria-label]="'ALT-TEXT.TENANT-SELECT' | translate">
                                <mat-icon aria-hidden class="m-0 material-symbols-rounded">tenancy</mat-icon>
                                <mat-icon aria-hidden class="m-0">arrow_drop_down</mat-icon>
                            </button>
                            <mat-menu #tenantMenu="matMenu">
                                <app-tenant-switch></app-tenant-switch>
                            </mat-menu>
                        </ng-container>
                    </li>
                    <li class="d-flex justify-content-center">
                        <button mat-flat-button type="button" color="primary" class="padded-shadow-btn" (click)="openNewPlanDialog()">{{ 'NAV-BAR.START-NEW-PLAN' | translate }}</button>
                    </li>
                </ul>
			</mat-menu>
		</div>

        <!-- Navbar Widget: segunda fila en móvil, columna derecha en escritorio -->
        <div class="widget-row">
            <navbar-root
                id="navbar-widget"
                [attr.selected-lang]="selectedLanguage"
                [attr.language]="navbarLanguage"
                [attr.languages]="navbarLanguagesJson"
                [attr.menu-items]="navbarMenuItemsJson"
            ></navbar-root>
        </div>
	</nav>
	<div *ngIf="progressIndication" class="progress-bar">
		<mat-progress-bar color="primary" mode="indeterminate" [attr.aria-label]="'ALT-TEXT.PROGRESS-BAR' | translate"></mat-progress-bar>
	</div>
</ng-container>
